import request from '@/http/http'
const PREFIX = 'api/audit-logging';
export function getAuditLogs(query) {
  return request({
    url: PREFIX + '/audit-logs/',
    params: query,
  })
}
export function getAuditLogDetails(id) {
  return request({
    url: PREFIX + '/audit-logs/' + id,
  })
}

export function getEntityChanges(query) {
  return request({
    url: PREFIX + '/audit-logs/entity-changes-with-user',
    params:query,
  })
}
